/* eslint-disable import/no-extraneous-dependencies */
import produce from 'immer';
import { CloseModalAction, CloseModalActionTypes } from './closeModalActions';

export interface CloseModalState {
  isOpen: boolean;
}

export const defaultCloseModalState: CloseModalState = {
  isOpen: false,
};

export const closeModalReducer = produce(
  (state: CloseModalState = defaultCloseModalState, action: CloseModalAction) => {
    switch (action.type) {
    case CloseModalActionTypes.Open: {
      state.isOpen = true;
      return state;
    }

    case CloseModalActionTypes.Close: {
      state.isOpen = false;
      return state;
    }

    default:
      return state;
    }
  },
);

export const closeModalOpen = (state: CloseModalState) => state.isOpen;
